exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.timer {\n    display: inline-block;\n    min-width: 50px;\n    white-space: nowrap;\n    float: right;\n    cursor: pointer;\n}\n.timer .prefix .text {\n    font-weight: bold;\n}\n.timer .block {\n    display: inline-block;\n    margin: 3px;\n}\n.timer .digit {\n    display: inline-block;\n    font-size: 19px;\n    color: #3c3c3c;\n}\n.timer .text {\n    display: inline-block;\n    font-size: 17px;\n    color: #6e6e6e;\n}\n", ""]);

// exports
